import * as PhotoSwipe from 'photoswipe';
import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import {
  fadeInWithIntersection,
  parallaxEffect,
  slideInWithIntersection
} from './parallax';
import {videoPlayer, youtubePlayer} from './players';

function sectionFaq(element) {
  const items = Array.from(element.querySelectorAll('.item'));

  for (const item of items) {
    const title = item.querySelector('.title');
    title.addEventListener('click', e => {
      e.preventDefault();

      item.classList.toggle('active');
    });
  }
}


function sectionBlock(element) {
  const gallery = element.querySelector('.gallery');

  if (gallery) {
    const pswp = element.querySelector('.pswp');
    const links = gallery.querySelectorAll('a');

    const items = [];

    links.forEach((c, i) => {
      items.push({
        src: c.getAttribute('href'),
        w: c.dataset.width,
        h: c.dataset.height,
        title: c.dataset.title || '',
      });

      const options = {
        index: i,
        shareEl: false,
      };

      c.addEventListener('click', e => {
        e.preventDefault();
        const pswpGallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);

        pswpGallery.init();
      });

    });
  }

  const video = element.querySelector('.video');
  if (video) {
    const videoLink = video.querySelector('a');
    videoLink.addEventListener('click', e => {
      e.preventDefault();

      if (videoLink.dataset.video) {
        videoPlayer(videoLink.dataset.video);
      } else if (videoLink.dataset.youtube) {
        youtubePlayer(videoLink.dataset.youtube);
      }
    });
  }
}

function sectionButtonBlock(element) {
  const video = element.querySelector('.video');

  if (video) {
    const videoLink = video.querySelector('a');

    if (videoLink) {
      videoLink.addEventListener('click', e => {
        e.preventDefault();

        if (videoLink.dataset.video) {
          videoPlayer(videoLink.dataset.video);
        } else if (videoLink.dataset.youtube) {
          youtubePlayer(videoLink.dataset.youtube);
        }
      });
    }
  }
}

function sectionTabs(element) {
  const nav = element.querySelector('nav');
  const active = nav.querySelector('.active');

  if (active) {
    const b1 = nav.getBoundingClientRect();
    const b2 = active.getBoundingClientRect();
    nav.scrollLeft = b2.left - b1.left - b1.width / 2 + b2.width / 2;
  }

  const update = () => {
    const pos = window.scrollY;

    const header = document.querySelector('header');
    const headerHeight = header.getBoundingClientRect().height;

    if (pos > headerHeight) {
      document.body.classList.add('tabs-fixed');
    } else {
      document.body.classList.remove('tabs-fixed');
    }
  };

  document.addEventListener('scroll', (e) => {
    update();
  });

  update();
}

function sectionCarousel(element) {
  //  Carousel handling - images in lightbox
  const carousel = element.querySelector('.carousel');

  if (carousel) {
    const pswp = element.querySelector('.pswp');
    const links = carousel.querySelectorAll('.image-element');

    const items = [];

    links.forEach((c, i) => {
      items.push({
        src: c.getAttribute('href'),
        w: c.dataset.width,
        h: c.dataset.height,
        title: c.dataset.title || '',
      });

      const options = {
        index: i,
        shareEl: false,
      };

      c.addEventListener('click', e => {
        e.preventDefault();
        const pswpGallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);

        pswpGallery.init();
      });

    });
  }

  //  Video handling:
  const videos = element.querySelectorAll('.video');

  if (videos.length > 0) {
    videos.forEach(video => {
      const videoLink = video.querySelector('a');

      if (videoLink) {
        videoLink.addEventListener('click', e => {
          e.preventDefault();

          if (videoLink.dataset.video) {
            videoPlayer(videoLink.dataset.video);
          } else if (videoLink.dataset.youtube) {
            youtubePlayer(videoLink.dataset.youtube);
          }
        });
      }
    })
  }
}

export function initSections() {
  document.querySelectorAll('.section-faq').forEach(c => sectionFaq(c));
  document.querySelectorAll('.section-faqNew').forEach(c => sectionFaq(c));
  document.querySelectorAll('.section-block').forEach(c => sectionBlock(c));
  document.querySelectorAll('.section-buttonBlock').forEach(c => sectionButtonBlock(c));
  document.querySelectorAll('.section-tabs').forEach(c => sectionTabs(c));
  document.querySelectorAll('.section-carousel').forEach(c => sectionCarousel(c));

  const sections = Array.from(document.querySelectorAll('.sections > div'));
  const elements = [];
  const fadeElements = [];

  for (const section of sections) {
    if (section.classList.contains('section-intro')) {
      elements.push(section.querySelector('h1'));
      elements.push(section.querySelector('h2'));
      elements.push(section.querySelector('form'));
    } else if (section.classList.contains('section-content')) {
      elements.push(section.querySelector('h3'));
      elements.push(section.querySelector('.description'));
      elements.push(section.querySelector('.links'));
    } else if (section.classList.contains('section-sign')) {
      elements.push(section.querySelector('form'));
    } else if (section.classList.contains('section-block')) {
      const hasRight = section.querySelector('.body').classList.contains('right');

      if (hasRight) {
        elements.push(section.querySelector('.gallery'));
        elements.push(section.querySelector('.image'));
      }

      elements.push(section.querySelector('.icon'));
      elements.push(section.querySelector('h3'));
      elements.push(section.querySelector('h4'));
      elements.push(section.querySelector('.content'));

      if (!hasRight) {
        elements.push(section.querySelector('.gallery'));
        elements.push(section.querySelector('.image'));
      }
    } else if (section.classList.contains('section-buttonBlock')) {
      parallaxEffect(section.querySelectorAll('.parallax-image'));

      const hasRight = section.querySelector('.body').classList.contains('right');

      if (hasRight) {
        fadeElements.push(section.querySelector('.image'));
        fadeElements.push(section.querySelector('.animated-images-wrapper'));
        fadeElements.push(section.querySelector('.gallery-wrapper'));
      }

      fadeElements.push(section.querySelector('.icon'));
      fadeElements.push(section.querySelector('h3'));
      fadeElements.push(section.querySelector('.content'));
      fadeElements.push(section.querySelector('.button'));


      if (!hasRight) {
        fadeElements.push(section.querySelector('.image'));
        fadeElements.push(section.querySelector('.animated-images-wrapper'));
        fadeElements.push(section.querySelector('.gallery-wrapper'));
      }
    } else if (section.classList.contains('section-faq')) {
      elements.push(...Array.from(section.querySelectorAll('.item')));
    } else if (section.classList.contains('section-faqNew')) {
      elements.push(...Array.from(section.querySelectorAll('.item')));
    } else if (section.classList.contains('section-course')) {
      elements.push(...Array.from(section.querySelectorAll('.row')));
    } else if (section.classList.contains('section-welcome')) {
      elements.push(section.querySelector('h2'));
      elements.push(...Array.from(section.querySelectorAll('.buttons > div')));
    } else if (section.classList.contains('section-header')) {
      parallaxEffect(section.querySelectorAll('.parallax-image'));

      fadeElements.push(section.querySelector('.icon'));
      fadeElements.push(section.querySelector('h1'));
      fadeElements.push(section.querySelector('h2'));
      fadeElements.push(section.querySelector('button'));
    } else if (section.classList.contains('section-carousel')) {
      fadeElements.push(section.querySelector('h3'));
      fadeElements.push(section.querySelector('.content'));
      fadeElements.push(section.querySelector('.button'));
    } else if (section.classList.contains('section-panorama')) {
      fadeElements.push(section.querySelector('h3'));
      fadeElements.push(section.querySelector('.content'));
    }
  }

  slideInWithIntersection(elements.filter(c => c));
  fadeInWithIntersection(fadeElements.filter(c => c));
}

// videoPlayer('http://localhost:10000/vizacademy-website/wp-content/uploads/2022/01/file_example_MP4_640_3MG.mp4');
